import { colorsPalettes } from "@similarweb/styles";

import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { TrafficSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import TruncatedTextWithTooltip from "app/pages/sales-intelligence/pages/company-analysis/components/shared/TruncatedTextWithTooltip/TruncatedTextWithTooltip";
import CountryService from "app/services/CountryService";

type TrafficSignalEventInfoProps = {
    signal: TrafficSignalEventDto;
};

const TrafficSignalEventInfoBox = ({ signal }: TrafficSignalEventInfoProps) => {
    const { countries } = signal;

    if (typeof countries !== "undefined" && countries.length > 1) {
        const countriesText = countries.map((countryId) => {
            const { text } = CountryService.getCountryById(countryId);
            return text;
        });
        const tags = signalEventsService.getSignalEventTags(signal);
        const title = `${tags.join(", ")} in ${countriesText.join(", ")}`;
        return (
            <TruncatedTextWithTooltip
                height={40}
                text={title}
                textStyles={{
                    fontVariant: "input2",
                    color: colorsPalettes.carbon[300],
                }}
            />
        );
    }

    return null;
};

export default TrafficSignalEventInfoBox;
